export default {"src":"/_next/static/media/payment.845d9ea5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};